import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/small-business")({
  head: () => ({
    meta: [
      ...routeMeta("/services/small-business"),
      { title: "Small Business Accounting | CCOB & Company" },
      { name: "description", content: "Full-service accounting, bookkeeping, payroll, and tax for Florida small businesses — one CPA partner for all your numbers." },
      { property: "og:title", content: "Small Business Accounting — CCOB And Company PA" },
      { property: "og:description", content: "Bookkeeping, payroll, tax, and CFO-level guidance under one roof." },
    ],
    links: canonicalLinks("/services/small-business"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Small Business Accounting"
      title="One CPA Partner for Every Number in Your Business"
      subtitle="Books, payroll, tax, and strategy — handled together, not in silos."
      hero={img.heroAccounting}
      image={img.accounting}
      intro="Small business owners shouldn't have to juggle three vendors for bookkeeping, payroll, and taxes. We bundle the work into one relationship — so the same CPA who closes your books also files your return and helps you plan ahead."
      items={[
        { title: "Monthly Bookkeeping", desc: "Reconciled books delivered on a predictable schedule, ready for decisions and lenders." },
        { title: "Payroll & Compliance", desc: "Full-service payroll with all federal, state, and local filings handled for you." },
        { title: "Sales Tax Filings", desc: "Florida sales-and-use tax prepared and filed monthly or quarterly, on time." },
        { title: "Business Tax Returns", desc: "S-Corp, C-Corp, LLC, and partnership returns — prepared by the CPA who knows your books." },
        { title: "Cash Flow Coaching", desc: "Quarterly reviews so you know what's coming in, what's going out, and what to do about it." },
        { title: "QuickBooks Setup & Support", desc: "Properly configured chart of accounts, integrations, and ongoing tune-ups." },
      ]}
    />
  ),
});
